var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "E-Commerce/shopping cart fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.5C1.22386 1.5 1 1.72386 1 2C1 2.27614 1.22386 2.5 1.5 2.5H2.06224L2.68868 7.19825C2.78804 7.94346 3.42371 8.5 4.17552 8.5H8.52301C9.20868 8.5 9.80706 8.03506 9.9765 7.37066L10.6665 4.66511C10.9083 3.71668 10.1918 2.79444 9.21298 2.79444H3.11035L3.05347 2.36784C2.98723 1.87103 2.56344 1.5 2.06224 1.5H1.5Z",
    fill: "#FB7185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10C2.5 9.44771 2.94772 9 3.5 9C4.05229 9 4.5 9.44772 4.5 10C4.5 10.5523 4.05229 11 3.5 11C2.94772 11 2.5 10.5523 2.5 10Z",
    fill: "#FB7185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9C8.44772 9 8 9.44771 8 10C8 10.5523 8.44772 11 9 11C9.55229 11 10 10.5523 10 10C10 9.44772 9.55229 9 9 9Z",
    fill: "#FB7185"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon);
export default __webpack_public_path__ + "static/media/category_icon.70103995c076af3cfbd34b6b346cb618.svg";
export { ForwardRef as ReactComponent };